module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Light.ae38fe5.woff";